export default [
    {
        path: '/index', //主页
        name: 'index',
        redirect: '/index/taskExamine_wait', //直接在这里设置重定向
        component: () => import('@/layout/IndexMain'),
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: 'taskExamine_my',
                name: 'taskExamineMy',
                component: () => import('@/views/Oa/taskExamine'),
            },
            {
                path: 'taskExamine_wait',
                name: 'taskExamineWait',
                component: () => import('@/views/Oa/taskExamineWait'),
            },
            {
                path: "execute",
                name: "execute",
                component: () => import("@/views/Oa/execute")

            },
            {
                path: "performance",
                name: "performance",
                component: () => import("@/views/Oa/performance")
            },
            {
                path: "statistics",
                name: "statistics",
                component: () => import("@/views/Oa/statistics")
            },
            {
                path: "efficiency-statistics",
                name: "efficiencyStatistics",
                component: () => import("@/views/Oa/efficiencyStatistics")
            },
            {
                path: "leaveBalance",
                name: "leaveBalance",
                component: () => import("@/views/Oa/leaveBalance")
            },
            {
                path: "learning-assessment",
                redirect: "/index/learning-assessment/question-bank",
                name: "learningAssessment",
                component: () => import("@/views/learning-assessment/manage/index.vue"),
                children: [
                    {
                        path: "question-bank",
                        name: "questionBank",
                        component: () => import("@/views/learning-assessment/manage/question-bank"),
                    },
                    {
                        path: "question-bank/info",
                        name: "questionInfo",
                        component: () => import("@/views/learning-assessment/manage/question-bank/question-info"),
                    },
                    {
                        path: "exam-paper",
                        name: "examPaper",
                        component: () => import("@/views/learning-assessment/manage/exam-paper"),
                    },
                    {
                        path: "study-materials",
                        name: "studyMaterials",
                        component: () => import("@/views/learning-assessment/manage/study-materials"),
                    },
                    {
                        path: "exam-results",
                        name: "examResults",
                        component: () => import("@/views/learning-assessment/manage/exam-results"),
                    },
                    {
                        path: "grade-statistics",
                        name: "gradeStatistics",
                        component: () => import("@/views/learning-assessment/manage/grade-statistics"),
                    }
                ]
            },
            {
                path: "my-assessment",
                redirect: "/index/my-assessment/exam",
                name: "myAssessment",
                component: () => import("@/views/learning-assessment/client/index.vue"),
                children: [
                    {
                        path: "exam",
                        name: "exam",
                        component: () => import("@/views/learning-assessment/client/exam/index.vue"),
                    },
                    {
                        path: "material",
                        name: "material",
                        component: () => import("@/views/learning-assessment/client/material/index.vue"),
                    }
                ]
            },
            {
                path: "notice-announcement",
                name: "noticeAnnouncement",
                component: () => import("@/views/notice-announcement/index.vue"),

            },
            {
                path: 'contract-archive',
                name: 'contractArchive',
                component: () => import('@/views/Oa/contractArchive')
            },
            {
                path: 'project-management',
                name: 'projectManagement',
                component: () => import('@/views/project-management/index.vue')
            },
            {
                path: 'supplier',
                name: 'supplier',
                component: () => import('@/views/supplier/index.vue')
            }
        ]
    },
    {
        path: "/index/my-assessment/exam/active",
        name: "examActive",
        component: () => import("@/views/learning-assessment/client/exam/moduels/examination-paper/index.vue"),
    }

]